import { Link } from "react-router-dom";
import "./navbar.css";

export default function Navbar() {
  return (
    <nav className="navbar">
      <div className="logo">Paschimanchal Vikas Parisad</div>

      <div className="nav-links">
        <Link to="/">Home</Link>
        <Link to="/about">About</Link>
        <Link to="/mission">Mission</Link>
        <Link to="/join">Join Us</Link>
      </div>

      <button className="join-btn">Connect</button>
    </nav>
  );
}